import styled from 'styled-components'
import {
	Breakpoints,
	media,
	textModels,
	themeObject,
} from 'Pages/landings/newLandings/common/style'

export const Title = styled.p`
	${textModels('heading', 'h2')}
	color: ${themeObject.colors.grey[800]};
	text-align: center;
	padding: 0 24px;
	${media('padding: 0', Breakpoints.ms)}
`

export const CustomBr = styled.br`
	${media('display: none', Breakpoints.ms)}
`
